<template>
    <div v-if="ecoRating !== null">
        <ob1-separateur class="my-2 mb-xl-3" />
        <!--/* Version Mobile */-->
        <div id="anchor-eco-rating" />
        <div class="d-lg-none">
            <div class="text-mw">
                <h2 v-html="ecoRating.title" />
                <div class="d-flex flex-column">
                    <img
                        :src="ecoRating.imageUrl"
                        :alt="ecoRating.alt"
                        class="img-fluid mw-100"
                    >
                    <p v-html="ecoRating.text" />
                    <ob1-liens
                        :href="ecoRating.linkUrl"
                        :text="ecoRating.linkWording"
                        :target="ecoRating.target"
                        :with-arrow="true"
                    />
                </div>
            </div>
        </div>
        <!--/* Version Desktop */-->
        <div class="d-none d-lg-block">
            <div class="row">
                <div class="col-6">
                    <h2 v-html="ecoRating.title" />
                    <p v-html="ecoRating.text" />
                    <ob1-liens
                        :href="ecoRating.linkUrl"
                        :text="ecoRating.linkWording"
                        :target="ecoRating.target"
                        :with-arrow="true"
                    />
                </div>
                <div class="col-6">
                    <img
                        :src="ecoRating.imageUrl"
                        :alt="ecoRating.alt"
                        class="pt-1 img-fluid mw-100"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EcoRating",
    props: {
        ecoRating: {
            type: Object,
            required: true
        },
    }
}
</script>
